// Mirror of backend _sync_trip_courses: apply a library course's tee data to linked trip courses.
export function syncTripCoursesFromLibrary(ev, lib) {
  const byId = Object.fromEntries((lib.teeBoxes || []).map((t) => [t.id, t]));
  const byName = Object.fromEntries((lib.teeBoxes || []).map((t) => [(t.name || "").trim().toLowerCase(), t]));
  let changed = 0;
  const courses = { ...(ev.courses || {}) };
  for (const [key, c] of Object.entries(courses)) {
    if (c.libraryId !== lib.id) continue;
    const tee = byId[c.teeId] || byName[(c.teeName || "").trim().toLowerCase()];
    if (!tee) continue;
    const same = JSON.stringify(c.par) === JSON.stringify(tee.par) && JSON.stringify(c.si) === JSON.stringify(tee.si);
    if (same) continue;
    courses[key] = { ...c, par: [...tee.par], si: [...tee.si], name: `${lib.name} — ${tee.name}`, subtitle: lib.subtitle || c.subtitle || "" };
    changed++;
  }
  ev.courses = courses;
  return changed;
}
